import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "account-bar bar pa-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_CustomButton = _resolveComponent("CustomButton")!
  const _component_DropdownMenu = _resolveComponent("DropdownMenu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_CustomButton, {
      level: _ctx.$enums.ButtonLevels.Tertiary,
      onClick: _ctx.toggleDropDown,
      class: "px-1"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_Icon, { icon: "account" })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["level", "onClick"]),
    _createVNode(_component_DropdownMenu, {
      items: _ctx.items,
      show: _ctx.opened,
      "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.opened) = $event)),
      modelValue: _ctx.modelValue,
      maxContent: true,
      "onUpdate:modelValue": _ctx.onModelValueUpdate
    }, null, 8, ["items", "show", "modelValue", "onUpdate:modelValue"])
  ]))
}